/**
 * This script watches the entire dom for special icon shortcuts and transforms them into fully qualified SVGs.
 */

export type Icon = {
	key: string;
	name: string;
	variant: string;
	data: string;
};

const ICON_CACHE: Record<string, Icon> = {};

const FALLBACK_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<path d="M21 3h-4v1h3v3h1V3zm-5 0h-2v1h2V3zm-3 0h-2v1h2V3zm-3 0H8v1h2V3zM7 3H3v4h1V4h3V3zm11.15 2.15L17 6.29l.7.71 1.15-1.15-.7-.7zm-12.3 0l-.7.7L6.29 7 7 6.3 5.85 5.14zm5.38.9l-.3.04h-.01a.59.59 0 00-.02.01h-.03-.01v.01h-.01-.01-.01-.01-.01v.01a.05.05 0 01-.01 0h-.03l-.01.01h-.01-.01-.01-.01l-.02.01h-.03l-.56.16-.01.01h-.02l-.01.01h-.02l-.01.01h-.01-.01l-.01.01h-.02l-.01.01h-.01-.01v.01h-.01-.01l-.02.01H9.9l-.18.08.38.92c.4-.16.83-.27 1.26-.33l-.13-1zm1.57 0l-.13 1c.42.05.85.17 1.25.33l.38-.92h-.01a.15.15 0 01-.01-.01h-.01-.01v-.01h-.02l-.01-.01h-.02v-.01h-.01-.01a.27.27 0 00-.01-.01h-.01-.01V6.4h-.01-.01l-.01-.01h-.01-.01v-.01h-.01-.01-.01v-.01h-.02l-.01-.01h-.01-.01v-.01H14l-.02-.01-.02-.01-.03-.01a5.99 5.99 0 00-1.13-.27zM8.36 7.23zm0 0zm0 0c-.41.31-.79.68-1.1 1.1l.78.61c.27-.34.58-.65.93-.92l-.6-.8zm7.3.02l-.6.79c.34.27.65.58.91.92l.8-.6a5.84 5.84 0 00-.09-.11v-.02h-.01v-.01h-.01V8.2h-.01V8.2h-.01v-.01h-.01v-.01l-.01-.01-.01-.02-.02-.01a5.96 5.96 0 00-.93-.9zM21 8h-1v2h1V8zM4 8H3v2h1V8zm10.15 1.15L13 10.29l.7.71 1.15-1.15-.7-.7zm-4.3 0l-.7.7L10.29 11l.71-.7-1.15-1.15zm-3.39.55v.01l-.01.01v.02h-.01v.02l-.01.01v.01a.1.1 0 00-.01.02v.01l-.01.01v.02H6.4v.03h-.01v.02l-.01.01v.02h-.01v.03l-.02.02V10l-.01.02v.02l-.01.02a2.09 2.09 0 00-.01.02c-.13.37-.22.75-.27 1.13l1 .13c.05-.43.17-.85.33-1.25l-.92-.38zm11.09.01l-.93.39c.17.4.28.82.34 1.26l1-.13a6.02 6.02 0 00-.07-.36v-.02-.02-.01l-.01-.02v-.01-.01-.01-.01h-.01v-.01-.01-.01-.01l-.01-.02a6.04 6.04 0 00-.26-.85.06.06 0 010-.01v-.01l-.01-.01a.1.1 0 010-.01V9.8h-.01v-.01-.01l-.01-.02-.02-.05zM21 11h-1v2h1v-2zM4 11H3v2h1v-2zm8 .3l-.7.7.7.7.7-.7-.7-.7zm-4.96 1.33l-1 .13.13.65v.04l.01.01v.04h.01v.03l.01.01v.02l.01.01v.01a.15.15 0 010 .01v.01l.01.01v.03h.01v.03a.32.32 0 01.01.01v.03l.01.01v.02a.05.05 0 00.01 0 .32.32 0 000 .01v.02l.01.02v.02l.01.01c.05.16.1.3.17.45l.92-.37c-.16-.41-.28-.83-.33-1.27zm9.92.03c-.06.43-.17.85-.34 1.26l.92.38v-.01l.01-.01v-.01a.14.14 0 010-.01h.01v-.01-.01a.08.08 0 00.01-.01v-.01l.01-.01v-.01a.3.3 0 010-.01h.01v-.01-.01-.01h.01v-.01-.01l.01-.01v-.01a.13.13 0 00.01-.02v-.01-.01h.01v-.01-.01l.01-.01v-.01-.01l.01-.01V14 14h.01v-.01-.01-.01h.01v-.01-.01-.01h.01v-.01-.01-.01h.01v-.01-.01-.01h.01v-.01-.01-.01h.01v-.01-.01-.01a.04.04 0 00.01 0v-.02-.01h.01v-.01-.01-.01l.01-.01v-.01-.01-.01h.01v-.01-.01-.01h.01v-.01-.01-.01l.01-.01v-.01a.06.06 0 000-.01v-.01h.01a.1.1 0 000-.02v-.01-.01h.01v-.01-.01-.01l.01-.01v-.01-.01-.01h.01v-.01-.01-.01-.01h.01v-.01a.15.15 0 010-.01v-.01-.01h.01a.1.1 0 000-.01.79.79 0 000-.02v-.01h.01v-.01-.02-.01a.16.16 0 01.01-.01v-.02-.02c.05-.17.08-.34.1-.5l-1-.14zM13.7 13l-.71.7 1.15 1.15.7-.7L13.71 13zm-3.42 0l-1.14 1.15.7.7L11 13.71l-.7-.71zM21 14h-1v2h1v-2zM4 14H3v2h1v-2zm4.02 1.03l-.8.6a6 6 0 00.3.35V16l.02.02v.01l.02.01v.01h.01v.01l.01.01.01.01.02.02v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01a.06.06 0 01.01 0v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01l.02.02v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01a.08.08 0 00.01 0v.01h.01v.01h.01v.01h.01v.01a.1.1 0 00.01 0v.01h.01v.01h.01v.01h.01l.01.01v.01h.01l.01.01.01.01h.01v.01h.01v.01h.01v.01H8v.01H8v.01h.01v.01h.01l.01.01.01.01h.01v.01h.01v.01h.01v.01h.01v.01h.01v.01h.01l.01.01h.01v.01h.01l.01.02h.01v.01h.01l.01.01.01.01.02.02.13.1.6-.8a4.97 4.97 0 01-.9-.92zm7.93.04c-.27.34-.58.65-.92.91l.6.8c.41-.31.79-.68 1.11-1.1l-.79-.61zm-5.87 1.55l-.38.92h.01l.01.01h.02v.01h.02v.01h.02a.09.09 0 00.01 0v.01a.16.16 0 00.02 0l.01.01h.02v.01h.03v.01h.02v.01h.03v.01h.03v.01h.02v.01H10l.02.01h.02v.01h.02l.02.01h.02a.1.1 0 010 .01h.02l.03.01c.35.12.7.2 1.05.25l.14-1a5.02 5.02 0 01-1.25-.33zm3.81 0c-.4.17-.83.29-1.26.34l.12 1c.53-.07 1.04-.2 1.52-.4l-.38-.93zM21 17h-1v3h-3v1h4v-4zm-3.3 0l-.7.7 1.15 1.15.7-.7L17.71 17zM6.3 17l-1.15 1.15.7.7L7 17.71 6.3 17zM4 17H3v4h4v-1H4v-3zm12 3h-2v1h2v-1zm-3 0h-2v1h2v-1zm-3 0H8v1h2v-1z" />
</svg>`;

const loadIcon = async (key: string, name: string, variant: string): Promise<Icon | null> => {
	try {
		// dynamically import the raw SVG contents from src/icons/**/*.svg
		const svg = await import(`../icons/${name}/${name}_${variant}.svg?raw`);
		if (!svg?.default) return null;

		const data = svg.default;
		return { key, name, variant, data };
	} catch (e) {
		console.warn(`Failed to import icon: [${name}:${variant}]\n`, e);
		return null;
	}
};

const getVariant = (sharp: boolean, filled: boolean, rtl: boolean) => {
	return `${sharp ? 'sharp' : 'round'}_${filled ? 'filled' : 'lined'}${rtl ? '_rtl' : ''}`;
};

const resolveIcon = async (name: string, variant?: string): Promise<Icon> => {
	// check the cache
	const key = `${name}:${variant ?? ''}`;
	if (key in ICON_CACHE) return ICON_CACHE[key];

	const v_sharp = variant?.includes('sharp') ?? false;
	const v_filled = variant?.includes('filled') ?? false;
	const v_rtl = variant?.includes('rtl') ?? false;

	let icon = await loadIcon(key, name, getVariant(v_sharp, v_filled, v_rtl));
	if (!icon) icon = await loadIcon(key, name, getVariant(!v_sharp, v_filled, v_rtl));
	if (!icon) icon = await loadIcon(key, name, getVariant(v_sharp, !v_filled, v_rtl));
	if (!icon) icon = await loadIcon(key, name, getVariant(!v_sharp, !v_filled, v_rtl));

	// fall back to non-RTL only if RTL is specifically specified in the variant
	if (v_rtl) {
		if (!icon) icon = await loadIcon(key, name, getVariant(v_sharp, v_filled, !v_rtl));
		if (!icon) icon = await loadIcon(key, name, getVariant(!v_sharp, v_filled, !v_rtl));
		if (!icon) icon = await loadIcon(key, name, getVariant(v_sharp, !v_filled, !v_rtl));
		if (!icon) icon = await loadIcon(key, name, getVariant(!v_sharp, !v_filled, !v_rtl));
	}

	if (icon) {
		// save to cache
		ICON_CACHE[icon.key] = icon;
		return icon;
	} else {
		return { key: '[placeholder]', name: '[placeholder]', variant: '', data: FALLBACK_ICON };
	}
};

const transformIcon = async (el: HTMLElement, name: string) => {
	if (!name) return;

	// load the icon
	const icon = await resolveIcon(name, el.dataset.v);

	// use a placeholder to generated the transformable SVG node
	const tmp = document.createElement('div');
	tmp.innerHTML = icon.data;
	const svg = tmp.querySelector('svg');
	if (!svg) return;
	svg.setAttribute('class', 'icon' + (el.className ? ' ' + el.className : ''));
	svg.dataset.icon = icon.name;
	if (icon.variant) svg.dataset.v = icon.variant;

	// delete built-in <title> tags inside the SVG
	svg.querySelectorAll('title').forEach(title => {
		title.parentElement?.removeChild(title);
	});

	// replace the span with the svg
	el.insertAdjacentElement('afterend', svg);
	el.parentElement?.removeChild(el);
};

const transformIcons = async () => {
	const icons = Array.from(document.querySelectorAll<HTMLSpanElement>('span[data-icon]'));

	// Immediately delete the [data-icon] attribute to prevent processing this tag multiple times while loading.
	// We save the icon name here on a different attribute so the batch procesor can still read it internally.
	for (const icon of icons) {
		icon.dataset.iconLoading = icon.dataset.icon;
		delete icon.dataset.icon;
	}

	// process icons per batch in case there are too many icons on the page
	const batchSize = 20;
	for (let i = 0; i < icons.length; i += batchSize) {
		const batch = icons.slice(i, i + batchSize);
		const promises: Promise<void>[] = [];
		for (const icon of batch) {
			const name = icon.dataset.iconLoading || '';
			promises.push(transformIcon(icon, name));
		}
		await Promise.allSettled(promises);
	}
};

export const init = () => {
	// first pass
	transformIcons();

	// start a full-page mutation observer to look for matching icon shortcuts
	const observer = new MutationObserver(transformIcons);

	observer.observe(document.body, {
		subtree: true,
		childList: true,
		attributes: true,
		attributeFilter: ['data-icon']
	});
};

export default {
	init
};
